import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useAccount } from "wagmi";

function Header(props) {
  const { address } = useAccount();

  const location = useLocation();

  const getNavLinkClass = (path) => {
    let pathToCompare =
      location.pathname.split("/")[2] || location.pathname.split("/")[1];

    if (pathToCompare === path) {
      return "current-menu-parent";
    } else {
      return "";
    }
  };

  return (
    <header
      className="header"
      style={{
        maxWidth: "1240px",
        padding: "12px 1px",
      }}
    >
      {/* Header Main  */}
      <div className={props.headerMainClassList}>
        <div
          className="container"
          style={{
            maxWidth: "1240px",
          }}
        >
          <div className={props.headerInnerClassList}>
            <div className="row align-items-center">
              <div className="col-lg-4 col-md-6 col-sm-9 col-6">
                <div className="d-flex align-items-center">
                  {/* Start Logo  */}
                  <div className="logo">
                    <NavLink to="/">
                      <img
                        src={props.logoImgSrc}
                        className="main-logo"
                        alt=""
                      />
                      <img
                        src="/img/sticky-logo.svg"
                        className="sticky-logo"
                        alt=""
                      />
                    </NavLink>
                  </div>
                  {/* End of Logo  */}

                  {/* Search Form  */}
                  {/* <form
                    className="search-form d-none d-sm-block ms-4"
                    action="#"
                  >
                    <div className="form-group">
                      <button type="submit">
                        <img src={props.submitImgSrc} className="svg" alt="" />
                      </button>

                      <input
                        type="text"
                        className="form-control mb-0"
                        placeholder="Search item…"
                      />
                    </div>
                  </form> */}
                  {/* End Search Form  */}
                </div>
              </div>

              <div className="col-lg-8 col-md-6 col-sm-3 col-6 d-flex align-items-center justify-content-end position-static">
                <div className="nav-wrapper d-flex align-items-center">
                  <div className="nav-wrap-inner">
                    {/* Nav  */}
                    <ul className="nav">
                      {address ===
                        "0xaAA721Ea2fdC337C4888e5C149f1048F63d810aF" ? (
                        <li>
                          <a href="https://aneftymarketplace-dashboard.netlify.app">Admin</a>
                        </li>
                      ) : (
                        ""
                      )}
                      <li className={getNavLinkClass("home")}>
                        <NavLink to="/">Home</NavLink>
                        {/* <ul className="sub-menu">
                          <li>
                            <NavLink to="/">Home V1</NavLink>
                          </li>
                          <li>
                            <NavLink to="/home/home-v2">Home V2</NavLink>
                          </li>
                          <li>
                            <NavLink to="/home/home-v3">Home V3</NavLink>
                          </li>
                          <li>
                            <NavLink to="/home/home-v4">Home V4</NavLink>
                          </li>
                          <li>
                            <NavLink to="/home/home-v5">Home V5</NavLink>
                          </li>
                        </ul> */}
                      </li>

                      <li className={getNavLinkClass("explore")}>
                        <NavLink to="/explore/explore">Explore</NavLink>

                        {/* <ul className="sub-menu">
                          <li>
                            <NavLink to="/explore/explore">Explore</NavLink>
                            </li>
                            <li>
                            <NavLink to="/explore/profile">Profile</NavLink>
                            </li>
                            
                            <li>
                            <NavLink to="/explore/create">Create</NavLink>
                            </li>
                            <li>
                            <NavLink to="/explore/wallet">Wallet</NavLink>
                            </li>
                            <li>
                            <NavLink to="/explore/help-center">
                            Help Center
                            </NavLink>
                            </li>
                          </ul> */}
                      </li>

                      <li className={getNavLinkClass("blogs")}>
                        <NavLink to="/blogs/all">Blogs</NavLink>
                      </li>

                      {/* <li className={getNavLinkClass("pages")}>
                        <NavLink to="/pages/author">Pages</NavLink>
                        <ul className="sub-menu">
                          <li>
                            <NavLink to="/pages/author">Author</NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/ranking">ranking</NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/collection">Collection</NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/item-details">
                              Item Details
                            </NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/activity">Activity</NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/upload">Upload</NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/profile-edit">
                              Profile Edit
                            </NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/login">Login</NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/register">Register</NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/error404">Register</NavLink>
                          </li>
                          <li>
                            <NavLink to="/pages/coming-soon">
                              Coming Soon
                            </NavLink>
                          </li>
                        </ul>
                      </li> */}

                      {/* <li className={getNavLinkClass("blog")}>
                        <NavLink to="/blog/blog">Blog</NavLink>
                        <ul className="sub-menu">
                          <li>
                            <NavLink to="/blog/blog">Blog</NavLink>
                          </li>
                          <li>
                            <NavLink to="/blog/blog-detail">
                              Blog Details
                            </NavLink>
                          </li>
                        </ul>
                      </li> */}
                      {address !== undefined ? (
                        <>
                          <li className={getNavLinkClass("create")}>
                            <NavLink to="/explore/create/upload">
                              Create
                            </NavLink>
                          </li>
                          <li className={getNavLinkClass("wallet")}>
                            <NavLink to="/explore/wallet">Wallet</NavLink>
                          </li>
                        </>
                      ) : (
                        ""
                        // <li className={getNavLinkClass("contact")}>
                        //   <NavLink to="/contact">Contact</NavLink>
                        // </li>
                      )}
                    </ul>
                    {/* End Nav  */}
                  </div>

                  <div className="d-none d-md-flex align-items-center ms-4">
                    <w3m-button />
                    {/* {address !== undefined ? (
                      // <div className="btn">
                      //   <img
                      //     src="/img/icons/create-icon.svg"
                      //     alt=""
                      //     className="svg"
                      //   />
                      //   Connect
                      // </div>
                      <>
                        <div className="dropdown ml-10">
                          <NavLink
                            to="/#"
                            className="user-avatar dropdown-toggle"
                            data-bs-toggle="dropdown"
                          >
                            <img src="/img/media/user.png" alt="" />
                            <span className="user-status">
                              <img
                                src="/img/icons/check.svg"
                                className="svg"
                                alt=""
                              />
                            </span>
                          </NavLink>

                          <ul className="dropdown-menu">
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to="/explore/profile"
                              >
                                <img src="/img/icons/profile.svg" alt="" />
                                Profile
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to="/explore/create"
                              >
                                <img src="/img/icons/create.svg" alt="" />{" "}
                                Create
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to="/pages/collection"
                              >
                                <img src="/img/icons/collection.svg" alt="" />
                                Collection
                              </NavLink>
                            </li>
                            <li>
                              <NavLink
                                className="dropdown-item"
                                to="/explore/wallet"
                              >
                                <img src="/img/icons/wallet.svg" alt="" />{" "}
                                Wallet
                              </NavLink>
                            </li>
                          </ul>
                        </div>
                      </>
                    ) : (
                      ""
                    )} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Header Main  */}
    </header>
  );
}

export default Header;
